/*
  Srovnávač LED 2 - obsah: produkty, ceny a rozložení stránky.
  Změna cen nebo produktů = jen blok VYCHOZI.
  Nadpis a úvodní text vykresluje stránka Srovnavac2Page.jsx z VYCHOZI.nadpis a VYCHOZI.perex.
*/

export const VYCHOZI = {
  verze: 11,
  firma: "LightWell",
  nadpis: "Kolik vás stojí světlo ve vašem boxu?",
  perex: "Zadejte rozměr rámu a parametry LED, které dnes používáte. Srovnávač spočítá cenu, světlo, příkon i záruku - na 1 m² i pro celý váš box - a postaví je vedle našich LEDBARů. LightWell LEDBARy - méně platíte, déle svítíte.",
  jednotkaPlochy: "m²",
  kus: "ks",
  rada: "LEDBAR",
  /* parametry jednoho kusu; lepsi: "nizsi" nebo "vyssi" */
  parametry: [
    { klic: "cena", nazev: "Cena", jednotka: "Kč", lepsi: "nizsi", des: 0 },
    { klic: "lm",   nazev: "Světelný tok", jednotka: "lm", lepsi: "vyssi", des: 0 },
    { klic: "w",    nazev: "Příkon", jednotka: "W", lepsi: "nizsi", des: 1 }
  ],
  /* vlastnosti, které se nenásobí počtem kusů (hodnota u produktu ve "vlastnosti") */
  vlastnosti: [
    { klic: "zaruka", nazev: "Záruka", jednotka: "let", lepsi: "vyssi", des: 0 }
  ],
  /* odvozené ukazatele: citatel / jmenovatel × nasobek */
  odvozene: [
    { nazev: "Účinnost", popis: "kolik světla dá 1 W", citatel: "lm", jmenovatel: "w", nasobek: 1, jednotka: "lm/W", lepsi: "vyssi", des: 0 },
    { nazev: "Cena světla", popis: "kolik stojí 1000 lm", citatel: "cena", jmenovatel: "lm", nasobek: 1000, jednotka: "Kč/1000 lm", lepsi: "nizsi", des: 1 }
  ],
  /* co si zákazník vybere a co určuje náš počet kusů na m² */
  volba: { nazev: "Hloubka boxu", jednotka: "mm", vychozi: 60 },
  /*
    Jediný provozní zdroj pravdy pro ceník srovnávače.
    Schválený IP20 ceník od 29. 9. 2026 pro obě IP20 varianty:
    20 ks = 65 Kč, 200 ks = 60 Kč, 400 ks = 55 Kč.
    Starší sada 60/55/50 Kč je neaktuální.
    hodnoty.cena odpovídá prvnímu (nejmenšímu) nákupu.
    tabulka = počet kusů na m² podle hloubky.
  */
  produkty: [
    { id: "8-6500-ip20", nazev: "LEDBAR 8W 6500K IP20", kryti: "IP20", popis: "IP20, interiér", hodnoty: { cena: 65, lm: 1040, w: 8 },
      nakup: [ {ks:20, cena:65}, {ks:200, cena:60}, {ks:400, cena:55} ], vlastnosti: { zaruka: 5 },
      tabulka: [ {hodnota:50, ks:7, poznamka:"rozteč 15cm"}, {hodnota:60, ks:5, poznamka:"rozteč 20cm"}, {hodnota:80, ks:5, poznamka:"rozteč 20cm"}, {hodnota:100, ks:5, poznamka:"rozteč 20cm"} ] },
    { id: "96-4000-ip20", nazev: "LEDBAR 9,6W 4000K IP20", kryti: "IP20", popis: "IP20, interiér", hodnoty: { cena: 65, lm: 1250, w: 9.6 },
      nakup: [ {ks:20, cena:65}, {ks:200, cena:60}, {ks:400, cena:55} ], vlastnosti: { zaruka: 5 },
      tabulka: [ {hodnota:50, ks:7, poznamka:"rozteč 15cm"}, {hodnota:60, ks:5, poznamka:"rozteč 20cm"}, {hodnota:80, ks:5, poznamka:"rozteč 20cm"}, {hodnota:100, ks:5, poznamka:"rozteč 20cm"} ] },
    { id: "96-6500-ip65", nazev: "LEDBAR 9,6W 6500K IP65", kryti: "IP65", venkovni: true, popis: "IP65, venkovní", hodnoty: { cena: 85, lm: 1250, w: 9.6 },
      nakup: [ {ks:10, cena:85}, {ks:150, cena:80}, {ks:300, cena:75} ], vlastnosti: { zaruka: 5 },
      tabulka: [ {hodnota:60, ks:5, poznamka:"rozteč 20cm"}, {hodnota:80, ks:5, poznamka:"rozteč 20cm"}, {hodnota:100, ks:4, poznamka:"rozteč 25cm"}, {hodnota:120, ks:4, poznamka:"rozteč 25cm"} ] }
  ],
  vychoziProdukt: "8-6500-ip20",
  /* krytí - zákazník vybírá své, srovnávač hlídá, aby se srovnávalo stejné s stejným */
  kryti: [ {hodnota:"IP20", nazev:"Interiér"}, {hodnota:"IP65", nazev:"Exteriér"} ],
  /* cena za kus podle velikosti nákupu: nakup u produktu = [{ks, cena}], cena null = zatím není */
  baleni: { klicCeny: "cena" },
  /* ukázkové hodnoty zákazníka - na stránce jsou označené jako příklad */
  priklad: { nazev: "", kryti: "IP20", ks: 8, cena: 45, lm: 700, w: 7.2, zaruka: 2 },
  provoz: { klicPrikonu: "w", klicCeny: "cena", klicSvetla: "lm" },
  /* rozměr počítané plochy - šířka × výška jednoho rámu (mm) × počet rámů */
  ramy: { sirka: 1000, vyska: 1000, pocet: 1 },
  /* odeslání výsledku - na webu aktivni: true; tady v ukázce se neodesílá */
  odeslani: { aktivni: true, url: "https://script.google.com/macros/s/AKfycbzlfmCPkh8FSG6do8zFJ5f7lTAzlobiRFyNAberOCJMvRsN4rL5sKNXYivo2kjaCd2X/exec" },
  paticka: "Naše hodnoty podle technického listu LEDBAR (vydáno 17. 8. 2026). Počet kusů na m² vychází z doporučené rozteče pro danou hloubku boxu. Výpočet je orientační, nezahrnuje zdroj, kabeláž ani montáž."
};

export const HTML = `<div class="obal">
  <section class="sekce" id="poleRozmer" aria-label="Rozměr rámu">
    <div class="karta">
      <div class="hlava-karty">
        <span class="popisek">Rozměr</span>
        <h2>Jak velkou plochu počítáme</h2>
      </div>
      <div class="pole" id="poleProjekt"></div>
    </div>
  </section>

  <section class="vstupy" aria-label="Zadání">
    <div class="karta">
      <div class="hlava-karty">
        <span class="popisek">Vaše svícení</span>
        <h2>Co používáte dnes</h2>
      </div>
      <div class="pole" id="poleZakaznik"></div>
      <span class="priklad" id="priklad">Vyplněno ukázkovými čísly - přepište je svými</span>
    </div>
    <div class="karta nase">
      <div class="hlava-karty">
        <span class="popisek" id="nasePopisek">Naše nabídka</span>
        <h2 id="naseNazev"></h2>
      </div>
      <div class="odznaky" id="odznaky"></div>
      <div class="pole" id="poleVarianta"></div>
      <dl class="pevne num" id="pevne"></dl>
    </div>
  </section>

  <div class="varovani" id="varovani" role="alert" hidden></div>

  <div class="kalk-lista">
    <button class="kalk-tlacitko" id="kalkTlacitko" type="button">KALKULACE</button>
    <p class="kalk-hlaska" id="kalkHlaska">Vyplňte údaje o vašich LED a klikněte na KALKULACE.</p>
  </div>

  <div class="vysledky" id="vysledky" hidden>
  <section class="verdikt" aria-live="polite">
    <span class="popisek">Výsledek na 1 m²</span>
    <h3 id="verdiktText"></h3>
    <div class="cisla num" id="verdiktCisla"></div>
    <div class="zaruka-pas" id="zarukaPas" hidden></div>
  </section>

  <section class="sekce rozmer-vysledek">
    <h2 id="rozmerNadpis">Výsledek pro váš rozměr</h2>
    <p class="maly" id="rozmerPopis" style="margin:0"></p>
    <div class="souhrn" id="souhrn"></div>
  </section>

  <section class="sekce">
    <h2>Cena za 1 m² - kolik ušetříte</h2>
    <div class="graf-karta">
      <div class="legenda" id="legendaSloupce"></div>
      <div class="panely" id="panely"></div>
    </div>
  </section>

  <section class="poslat" aria-labelledby="poslatNadpis">
    <div class="poslat-text">
      <h2 id="poslatNadpis">Pošlete si výsledek na e-mail</h2>
      <p>Srovnání vám přijde i s cenou za celý projekt. Stačí odpovědět a připravíme nabídku.</p>
    </div>
    <form id="formPoslat" class="poslat-form" novalidate>
      <label for="f_email" class="f-email">Váš e-mail<span class="vstup"><input id="f_email" type="email" autocomplete="email" placeholder="jmeno@firma.cz" required></span></label>
      <label class="f-souhlas" for="f_souhlas"><input id="f_souhlas" type="checkbox"> <span>Chci dostávat novinky a nabídky LightWell. Souhlas můžete kdykoli odvolat.</span></label>
      <input id="f_web" name="web" type="text" tabindex="-1" autocomplete="off" aria-hidden="true" class="past">
      <button class="hlavni" id="f_tlacitko" type="submit">Poslat výsledek na e-mail</button>
      <p class="f-hlaska" id="f_hlaska" role="status"></p>
      <p class="maly f-pozn">E-mail použijeme k odeslání výsledku. Bez souhlasu vám nic dalšího posílat nebudeme.</p>
    </form>
  </section>

  <section class="sekce">
    <h2>Srovnání parametr po parametru</h2>
    <p class="maly" style="margin:0">Zelené zatržítko = lepší hodnota. Rozdíl ukazuje, o kolik je naše nabídka lepší (zeleně) nebo horší (oranžově).</p>
    <div class="tabulka-obal"><table class="num">
      <thead><tr><th>Na 1 m²</th><th id="thVase">Vaše LED</th><th class="nase-h" id="thNase">Naše nabídka</th><th>Rozdíl</th></tr></thead>
      <tbody id="tabulka"></tbody>
    </table></div>
  </section>
  </div>

  <footer id="paticka"></footer>
</div>

`;
